// extracted by mini-css-extract-plugin
export default {"style":"Phone_style__Lu7GZ"};